"use client";
import * as React from "react";
const SvgBuildSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M7.95 1.355A4.672 4.672 0 0 0 2.615.47l3.111 3.102-2.15 2.144L.464 2.613a4.638 4.638 0 0 0 .896 5.31A4.675 4.675 0 0 0 6.3 8.981L13.34 16 16 13.348 8.989 6.351a4.641 4.641 0 0 0-1.04-4.996Z" }));
export {
  SvgBuildSharp as default
};
